"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fluxActions = require("flux-actions");

var _mapPayloadTo = _interopRequireDefault(require("../utils/mapPayloadTo"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _default = function _default(_ref) {
  var actionTypes = _ref.actionTypes,
      property = _ref.property;
  var removeFromSet = property + "/" + _ActionTypes.default.REMOVE_FROM_MAP;
  return (0, _fluxActions.createAction)(actionTypes[removeFromSet], (0, _mapPayloadTo.default)(property));
};

exports.default = _default;
module.exports = exports.default;